// Generated by tools/sync-data.ts — do not edit.
import type { ChapterData } from '../../../systems/adventures/types.js';

export const chapterLoaders: (() => Promise<ChapterData>)[] = [
  () => import('./chapter-00.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-01.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-02.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-03.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-04.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-05.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-06.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-07.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-08.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-09.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-10.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-11.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-12.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-13.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-14.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-15.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-16.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-17.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-18.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-19.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-20.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-21.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-22.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-23.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-24.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-25.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-26.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-27.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-28.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-29.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-30.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-31.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-32.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-33.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-34.json').then((m) => m.default as unknown as ChapterData),
  () => import('./chapter-35.json').then((m) => m.default as unknown as ChapterData),
];
